import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { getLanguage } from '../../../../utils/params';

const WhyChooseContent = (props) => {
  const { data } = props
  const language = getLanguage(useLocation());

  return (
    <>
      {data && data.length
        ? data.slice(0,4).map((item, index) => {
            if (index % 2 === 0)
              return (
                <div className="choose-us-block" key={index}>
                  <div className="row">
                    <div className="col-12 col-md-3">
                      <div className="why-choose-image">
                        <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`} className="h-100 w-100" alt="" />
                        {/* <LazyLoadImage
                        src={images[`Image${index + 1}`]}
                        className="h-100 w-100" alt="" effect="blur" /> */}
                      </div>
                    </div>
                    <div className="col-1" />
                    <div className="col-12 col-md-8">
                      <div className="choose-us-content">
                        <div className="row">
                          <div className="col-12">
                            <div className="choose-us-title jp-bold-600">{item.title}</div>
                          </div>
                        </div>
                        <div className="choose-us-description jp-font-sawarabi-gothic">
                          <p>
                            {item.content}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            return (
              <div className="choose-us-block" key={index}>
                <div className="row">
                  <div className="col-1" />
                  <div className="col-12 col-md-8">
                    <div className="choose-us-content pl-sm-4">
                      <div className="row">
                        <div className={`col-12 ${language === 'jp' ? '' : 'col-md-6'}`}>
                          <div className="choose-us-title jp-bold-600">{item.title}</div>
                        </div>
                      </div>
                      <div className="choose-us-description jp-font-sawarabi-gothic">
                          <p>
                            {item.content}
                          </p>
                        </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="why-choose-image">
                      <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`} className="h-100 w-100" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : ''}
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WhyChooseContent);
